import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueColorsHeatMapSigned'
})
export class ValueColorsHeatMapSignedPipe implements PipeTransform {
  transform(
    value: any,
    minValue: number,
    maxValue: number,
    inverse?: boolean
  ): any {
    const positiveValuesClassNames = ['green1', 'green2', 'green3'];
    const negativeValuesClassNames = ['red1', 'red2', 'red3'];

    if (!value || minValue === null || maxValue === null) return '';
    const step = value > 0 ? maxValue / 3 : minValue / 3;
    const index = Math.ceil(value / step) - 1;
    if (index <= 2 && index >= 0) {
      if (!inverse) {
        return value > 0
          ? positiveValuesClassNames[index]
          : negativeValuesClassNames[index];
      } else {
        // if the colors should be reversed based on the numbers
        return value > 0
          ? negativeValuesClassNames[index]
          : positiveValuesClassNames[index];
      }
    } else {
      return '';
    }
  }
}
